module.exports = __webpack_public_path__ + "static/media/python.0f87c1f3.svg";